import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import { getClimateIndexColor, getMonthName } from 'helper/Meteorology/climateIndicesLabels';
import { IndiceClimatico } from 'types/Meteorology/indicesClimaticos';
import { cssVar } from 'constants/theme';
import INDICES from '../indices';

import './index.scss';

export interface YearCardProps {
  row: IndiceClimatico;
  hasMap: boolean;
  active?: boolean;
  onToggle?: () => void;
}

export default function YearCard({
  row, hasMap, active = true, onToggle,
}: YearCardProps) {
  const monthAbbr = getMonthName(row.mes).slice(0, 3);
  const checked = hasMap && active;

  const content = (
    <>
      <div className="agro-simil-year-card-header">
        <span className="agro-simil-year-card-check">
          {checked && <Icon iconType="checkmark" color={cssVar('text-on-accent')} size="small" />}
        </span>
        <span className="agro-simil-year-card-year">{row.ano}</span>
        <span className="agro-simil-year-card-month">{monthAbbr}</span>
        {hasMap && (
          checked ? (
            <span className="agro-simil-year-card-badge">
              <Icon iconType="checkmark" color={cssVar('success-fg')} size="small" />
              mapa
            </span>
          ) : (
            <span className="agro-simil-year-card-badge excluded">excluído</span>
          )
        )}
      </div>
      <div className="agro-simil-year-card-chips">
        {INDICES.map(({ id, abbr, type }) => (
          <span key={id} className="agro-simil-year-card-chip">
            <span
              className="agro-simil-year-card-chip-dot"
              style={{ background: getClimateIndexColor(row[id], type) }}
            />
            {abbr}
            {' '}
            <strong>{row[id].toFixed(2)}</strong>
          </span>
        ))}
      </div>
    </>
  );

  if (!hasMap) {
    return <div className="agro-simil-year-card">{content}</div>;
  }

  return (
    <button
      type="button"
      className={`agro-simil-year-card has-map${checked ? '' : ' excluded'}`}
      onClick={onToggle}
    >
      {content}
    </button>
  );
}
